<template>
  <div>
    <transition name="vc-alert-fade">
      <div
        v-if="shown"
        class="vc-alert"
        :class="alertClass"
      >
        <div class="vc-alert__content">
          <status-icon
            :status="color"
            size="large"
          />
          <div class="vc-alert__text">
            <p v-if="title" class="vc-alert__title">{{ title }}</p>
            <p class="vc-alert__message">{{ message }}</p>
          </div>
        </div>

        <div class="vc-alert__actions">
          <v-btn
            v-if="isInfo"
            outline
            color="info"
            class="vc-alert__retry"
            @click="handleShowModalPassword"
          >
            Cambiar contraseña
          </v-btn>
          <v-btn
            v-if="isError"
            outline
            color="error"
            class="vc-alert__retry"
            :loading="isRetrying"
            :disabled="isRetrying"
            @click="handleRetry"
          >
            Reintentar
          </v-btn>
          <v-btn
            v-if="shownButtonClose"
            icon
            flat
            class="vc-alert__close"
            @click="shown = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </div>
    </transition>

    <zt-modal :active="modalActive" @close="modalActive = false" max-width="42rem" :z-index="200" :fullscreen="isMobile">
      <template slot="modal-header">
        <div class="p-4 font-normal text-zt-lg text-center md:text-left">
          <h4>Editar contraseña</h4>
        </div>
      </template>
      <editPassword @close="modalActive = false" @success="modalActive = false; shown = false" />
    </zt-modal>
  </div>
</template>

<script>
import StatusIcon from './StatusIcon.vue'
import editPassword from '@/components/Header/modals/EditPassword'
import { useWindowResize } from '@sichern/ui-elements'

export default {
  name: 'AlertSichernConnectNotificacion',
  components: { StatusIcon, editPassword },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: { type: Boolean, default: false },
    color: { type: String, default: 'danger' },
    message: { type: String, default: '' },
    title: { type: String, default: '' },
    shownButtonClose: { type: Boolean, default: false }
  },
  data () {
    return {
      isRetrying: false,
      modalActive: false,
      windowSize: useWindowResize(this)
    }
  },
  computed: {
    shown: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    isError () {
      return this.color === 'danger'
    },
    isInfo () {
      return this.color === 'info'
    },
    isMobile () {
      return this.windowSize.width < 1024
    },
    alertClass () {
      if (this.color === 'danger') return 'vc-alert--error'
      if (this.color === 'info') return 'vc-alert--info'
      return 'vc-alert--success'
    }
  },
  methods: {
    async handleRetry () {
      if (this.isRetrying) return
      if (this.isError) {
        try {
          this.isRetrying = true
          await this.$store.dispatch('sichernConnect/requestLinkingStatus')
          this.shown = false
        } finally {
          this.isRetrying = false
        }
        return
      }
      this.shown = false
    },
    handleShowModalPassword () {
      this.modalActive = true
    }
  }
}
</script>

<style scoped lang="scss">
.vc-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 5px;
  border: 1px solid;
  margin-bottom: 1rem;

  &--success {
    background: #d4edda;
    border-color: #027A55;
    color: #027A55;

  }

  &--error {
    background: #fde8e8;
    border-color: #B41818;
    color: #B41818;
  }

  &--info {
    background: #E6F2FE;
    border-color: #84CAFF;
    color: #1849A9;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 1.25rem;
  }

  &__text {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0;
  }

  &__message {
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__retry,
  &__close {
    flex-shrink: 0;
  }
}

@media (max-width: 768px) {
  .vc-alert {
    flex-direction: column;
    position: relative;
    width: calc(100% - 3rem);
    margin: 20px auto 0;
  }

  .vc-alert__content {
    flex-direction: column;
  }

  .vc-alert__actions .vc-alert__retry {
    margin-top: 20px
  }

  .vc-alert__actions button.vc-alert__close {
    position: absolute;
    top: 0px;
    right: 0px;
  }
}

.vc-alert-fade-enter-active,
.vc-alert-fade-leave-active {
  transition: opacity 0.2s ease;
}

.vc-alert-fade-enter,
.vc-alert-fade-leave-to {
  opacity: 0;
}
</style>
